import m from "../../geodata/es2015/tanzaniaHigh";
window.am4geodata_tanzaniaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/tanzaniaHigh.js
// module id = null
// module chunks = 